import { Button, Card } from 'antd';
import useQueryParams from 'hooks/useQueryParams';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { apps } from 'modules/apps/apps.config';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import CalendlyModal from 'components/Modals/CalendlyModal';
import Icon from '@mdi/react';
import { mdiCalendarMonth } from '@mdi/js';

const AppCard = ({ app }) => {
  const [open, setOpen] = useState(false);
  const { setUrlParams } = useQueryParams();
  const history = useHistory();

  if (typeof app === 'string') {
    if (typeof apps[app] === 'undefined') {
      return 'Invalid App';
    }
    app = apps[app];
  }

  const onCardClick = () => {
    if (app.url) {
      history.push(app.url);
    } else {
      setUrlParams({ app: app.app });
    }
  };

  return (
    <div className='relative'>
      <Card
        className={`h-full ${
          app.disable ? 'opacity-50 pointer-events-none' : 'hover:shadow-md cursor-pointer'
        }`}
        size='small'
        onClick={onCardClick}
        cover={
          <img
            src={app.image}
            className='w-1/2 py-2 h-[150px] px-[20%] m-auto object-contain'
            alt={app.name}
          />
        }
        bordered
      >
        <Card.Meta title={app.name} description={app.description} />
      </Card>
      {app.disable && (
        <div className='absolute z-90  bottom-0 bg-white w-full rounded-b-md p-4 sm:flex grid gap-2 items-end gap-1 justify-between'>
          <Card.Meta title={app.name} description={app.description} />
          <Button
            size='small'
            type='primary'
            className='right-0 left-0 w-fit'
            onClick={() => setOpen(true)}
            icon={<Icon path={mdiCalendarMonth} size={0.6} />}
          >
            Schedule a call
          </Button>
        </div>
      )}
      <CalendlyModal open={open} onCancel={() => setOpen(false)} />
    </div>
  );
};

AppCard.propTypes = {
  app: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default AppCard;
